export const DashboardTabs = {
    rdarrReimagined: 1,
    evidenceBasedApproach: 2,
    dataQuality: 3,
    riskAndFinanceAlignment: 4,
    sarbSelfAssessment: 5,
};

export const RdarrReimaginedTabs = {
    rdarrFrameworks: 1,
    groupCommittees: 2,
    components: 3,
};
